export const GroupsStore = {
    namespaced: true,
    state: {
        groups: [],
        group: {}
    },
    mutations: {
        setGroups(state: any, response: any) {
            state.groups = response;
        },
        setGroup(state: any, response: any) {
            state.group = response;
        }
    },
    actions:{
        setGroups(context: any, response: any) {
            context.commit('setGroups', response);
        },
        setGroup(context: any, response: any) {
            context.commit('setGroup', response);
        }
    },
    getters: {
        getGroups: (state: any) => state.groups,
        getGroup: (state: any) => state.group
    }
}